/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_All_TimeInputs */

const en_ui_filter_all_time = /** @type {(inputs: Ui_Filter_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all time`)
};

const de_ui_filter_all_time = /** @type {(inputs: Ui_Filter_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gesamter Zeitraum`)
};

/**
* | output |
* | --- |
* | "all time" |
*
* @param {Ui_Filter_All_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_all_time = /** @type {((inputs?: Ui_Filter_All_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_All_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_all_time(inputs)
	return de_ui_filter_all_time(inputs)
});